import isNil from "lodash/fp/isNil";

class Controller {
  constructor(Events, $stateParams, Sections) {
    "ngInject";

    this.page = $stateParams.page;
    this.limit = $stateParams.limit;
    this.activeParams = $stateParams;

    this.filterEvent = Events.getFilterEvent("bookings");
    this.sortEvent = Events.getSortEvent("bookings");
    this.paginateEvent = Events.getPaginateEvent("bookings");
    this.sections = Sections.bookingsSections;
  }

  getInterceptor(params) {
    if (
      isNil(params.user) &&
      isNil(params.date) &&
      isNil(params.start_date) &&
      isNil(params.end_date)
    ) {
      return "You need at least to choose a User or a Date or a Start and End Date in order to display the bookings";
    }
    return true;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bookings/bookings.controller.js